import { render, staticRenderFns } from "./appointmentRecord.vue?vue&type=template&id=40d70a97&scoped=true"
import script from "./appointmentRecord.vue?vue&type=script&lang=js"
export * from "./appointmentRecord.vue?vue&type=script&lang=js"
import style0 from "./appointmentRecord.vue?vue&type=style&index=0&id=40d70a97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d70a97",
  null
  
)

export default component.exports